import { useEffect, useRef } from 'react';

import {
  addPrefixToAnalyticProp,
  AnalyticsEvents,
  event,
} from 'utils/analytics';
import { areDeepEqual } from 'utils/deepEqual';
import { Size } from '__generated__/graphql';

import { usePageEventsContext } from './usePageEventsContext';

type ItemViewProps = {
  itemListId?: string;
  itemListName?: string;
  itemIdEp?: string;
  itemNameEp?: string;
  imageType?: string;
  imageNumber?: string;
  value?: number;
  item?: any;
  currency?: string;
  desiredSize?: string;
  selectedSize?: Size;
};

export const useItemViewEvent = ({
  itemListId,
  itemListName,
  itemIdEp,
  itemNameEp,
  imageType,
  imageNumber,
  value,
  item,
  currency,
  desiredSize,
  selectedSize,
}: ItemViewProps) => {
  const previousItemRef = useRef<any>();
  const { pageviewEventHasFired } = usePageEventsContext();

  useEffect(() => {
    const hasAlreadyExecuted = areDeepEqual(previousItemRef.current, item);

    const hasCategory = item?.item_category !== null;

    if (
      item &&
      hasCategory &&
      !hasAlreadyExecuted &&
      pageviewEventHasFired &&
      (!desiredSize || selectedSize)
    ) {
      event(AnalyticsEvents.GA4EC_ItemView, {
        event_name: AnalyticsEvents.VIEW_ITEM,
        ecommerce: {
          item_list_id: itemListId,
          item_list_name: itemListName,
          item_id_ep: itemIdEp,
          item_name_ep: itemNameEp,
          value,
          image_type: imageType,
          image_number: imageNumber,
          items: [
            !selectedSize
              ? item
              : {
                  ...item,
                  item_variant: selectedSize.productId,
                  size: addPrefixToAnalyticProp(selectedSize.label),
                },
          ],
          currency,
        },
      });
      previousItemRef.current = item;
    }
  }, [
    itemListId,
    itemListName,
    itemIdEp,
    itemNameEp,
    imageType,
    imageNumber,
    value,
    item,
    pageviewEventHasFired,
    currency,
    desiredSize,
    selectedSize,
  ]);
};
